import React from "react";
import MDBox from "shared/ui/Box/MDBox";
import Icon from "@mui/material/Icon";
import PropTypes from "prop-types";
import { alpha } from "@mui/material/styles";

export default function ViewModeSelector({ viewMode, setViewMode }) {
  return (
    <MDBox
      sx={{
        display: "flex",
        width: "100%",
        borderRadius: "999px",
        border: "1px solid",
        borderColor: "grey.300",
        backgroundColor: "background.paper",
        overflow: "hidden",
      }}
    >
      {/* Planner */}
      <MDBox
        onClick={() => setViewMode("planner")}
        sx={{
          flex: 1,
          py: 1,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "6px",
          fontSize: "0.8rem",
          fontWeight: 600,
          color: viewMode === "planner" ? "primary.main" : "text.secondary",
          backgroundColor:
            viewMode === "planner"
              ? (theme) => alpha(theme.palette.primary.main, 0.1)
              : "transparent",
          transition: "all 0.2s ease",
          "&:hover": {
            backgroundColor:
              viewMode === "planner"
                ? (theme) => alpha(theme.palette.primary.main, 0.15)
                : "grey.100",
          },
        }}
      >
        <Icon sx={{ fontSize: 18 }}>calendar_today</Icon>
        <span>Rutina</span>
      </MDBox>

      {/* Divider */}
      <MDBox
        sx={{
          width: "1px",
          backgroundColor: "grey.300",
        }}
      />

      {/* Notes */}
      <MDBox
        onClick={() => setViewMode("notes")}
        sx={{
          flex: 1,
          py: 1,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "6px",
          fontSize: "0.8rem",
          fontWeight: 600,
          color: viewMode === "notes" ? "primary.main" : "text.secondary",
          backgroundColor:
            viewMode === "notes"
              ? (theme) => alpha(theme.palette.primary.main, 0.1)
              : "transparent",
          transition: "all 0.2s ease",
          "&:hover": {
            backgroundColor:
              viewMode === "notes"
                ? (theme) => alpha(theme.palette.primary.main, 0.15)
                : "grey.100",
          },
        }}
      >
        <Icon sx={{ fontSize: 18 }}>notes</Icon>
        <span>Detalles</span>
      </MDBox>
    </MDBox>
  );
}

ViewModeSelector.propTypes = {
  viewMode: PropTypes.string.isRequired,
  setViewMode: PropTypes.func.isRequired,
};
